import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import HelpSection from './left-content.md';
import QuestionsSection from './right-content.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const WrapperComponent = makeShortcode("WrapperComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <WrapperComponent slots="content" theme="lightest" className="w-50" mdxType="WrapperComponent" />
    <HelpSection mdxType="HelpSection" />
    <WrapperComponent slots="content" theme="lightest" className="w-50 volume-content" mdxType="WrapperComponent" />
    <QuestionsSection mdxType="QuestionsSection" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      